import React from 'react'
import styled from 'styled-components'
import IconListSparse from '../../images/icon-list-sparse.svg'
import IconListCompact from '../../images/icon-list-compact.svg'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import useScreenSize from '../../utilities/useScreenSize';
import { LAPTOP } from '../../utilities/breakpoints'

const ViewToggler = ({viewMode = "sparse", handleVMChange, useTranslate}) => {

  const screenSize = useScreenSize();
  const toolTipOnTop = screenSize.width >= 600;

  return (
    <div className="view-toggle-container">
      <label>{ useTranslate("data_vault.select_view_label") }</label>
      <ButtonContainer className={"view-toggler"}>
        <OverlayTrigger
          placement={toolTipOnTop ? "top" : "bottom"}
          overlay={
            <Tooltip id="tt-detail">
              {useTranslate("data_vault.detail_view_tooltip")}
            </Tooltip>
          }
        >
          <ViewButton
            className={`${viewMode === "sparse" ? 'active' : ''}`}
            onClick={() => handleVMChange("sparse")}
          >
            <img src={IconListSparse} alt="List sparse"/>
          </ViewButton>
        </OverlayTrigger>

        <OverlayTrigger
          placement={toolTipOnTop ? "top" : "bottom"}
          overlay={
            <Tooltip id="tt-compact">
              {useTranslate("data_vault.compact_view_tooltip")}
            </Tooltip>
          }
        >
          <ViewButton
            className={`${viewMode === "compact" ? 'active' : ''}`}
            onClick={() => handleVMChange("compact")}
          >
            <img src={IconListCompact} alt="List compact"/>
          </ViewButton>
        </OverlayTrigger>
      </ButtonContainer>
    </div>
  )
}

export default ViewToggler;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #fff;
  border: 1px solid #EBE9E4;
  padding: 0 15px;
  border-radius: 10px;
  height: 40px;
  
  @media${LAPTOP} {
    height: 52px;
    padding: 0 20px;
  }
`;

const ViewButton = styled.a`
  border: none;
  outline: none;
  background: none;
  background-color: transparent;
  cursor: pointer;
  transition: filter .3s ease-in-out;
  
  img {
    filter: invert(48%) sepia(36%) saturate(351%) hue-rotate(164deg) brightness(91%) contrast(88%);
  }
  
  &.active img {
    filter: invert(51%) sepia(83%) saturate(1407%) hue-rotate(351deg) brightness(101%) contrast(98%);
  }
  
  &:hover,
  &:active,
  &:focus {
    outline: none;
    
    img {
      filter: invert(51%) sepia(83%) saturate(1407%) hue-rotate(351deg) brightness(101%) contrast(98%);
    }
  }
`;


// WEBPACK FOOTER //
// ./src/components/ui/view-toggler.js